import { render, staticRenderFns } from "./VMeta.vue?vue&type=template&id=12737b62&"
import script from "./VMeta.vue?vue&type=script&lang=js&"
export * from "./VMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports